import angular from 'angular';
import { assign, cloneDeep, every, flatten, includes, isEmpty, map, some, uniq } from 'lodash';
import '../services/organization';
import '../services/place';
import '../services/user';
import '../services/errors';
import '../services/tags';
import '../services/tags-groups';
import './modals/tags-groups';
import { localStorage } from '../utils';

const module = angular.module('whyline.controllers.tags', [
  'whyline.services.organization',
  'whyline.services.place',
  'whyline.services.user',
  'whyline.services.errors',
  'whyline.services.tags',
  'whyline.services.tags-groups',
  'whyline.modals.tags-groups',
]);

const TagsController = (
  $scope,
  $uibModal,
  $timeout,
  OrganizationService,
  PlaceService,
  ErrorService,
  TagsService,
  TagsGroupsService,
  NotificationService,
  $translate,
) => {
  'ngInject';

  const organization = OrganizationService.GetCurrent();
  $scope.organizationId = organization._id;
  $scope.tagsGroups = TagsGroupsService.GetAll();
  $scope.activeTab = 1;
  $scope.places = [];
  $scope.unfilteredPlacesList = []; // to filter list of places by tags
  $scope.tagsGroupsList = [];
  $scope.titleGroupTag = [];
  $scope.selectedTags = [];
  $scope.savedTagsFilter = [];
  $scope.tagsFilterNotResults = false;
  $scope.loaded = false;
  $scope.selectAllPlaces = false;
  $scope.disabledTagSelector = true;
  $scope.searchBox = {
    name: '',
    info: {
      address: '',
      state: '',
    },
    branchId: '',
  };
  $scope.tagsGroupsSettings = {
    template: '<translate>{{option.tagName}}</translate>',
    externalIdProp: '',
    displayProp: 'tagName',
    idProp: '_id',
    searchField: 'tagName',
    enableSearch: true,
    clearSearchOnClose: true,
    keyboardControls: true,
    selectedToTop: true,
    scrollable: true,
    showCheckAll: false,
    showUncheckAll: true,
    selectByGroups: $scope.titleGroupTag,
    groupByTextProvider: (groupValue) => {
      const tagGroupName = map($scope.tagsGroups, (groupTag) => groupTag.name);
      if (includes(tagGroupName, groupValue)) {
        if (!includes($scope.titleGroupTag, groupValue)) {
          $scope.titleGroupTag.push(groupValue);
        }
        return groupValue;
      }
    },
    groupBy: 'groupName',
  };
  $scope.multiSelectTranslations = {
    checkAll: $translate.instant('all'),
    uncheckAll: $translate.instant('multiselect_ninguno'),
    selectGroup: $translate.instant('select_all'),
    dynamicButtonTextSuffix: $translate.instant('multiselect_seleccionados'),
    buttonDefaultText: $translate.instant('search_by_tag'),
    searchPlaceholder: $translate.instant('search_tag'),
  };

  const filterByTagGroup = () => {
    $scope.places = cloneDeep($scope.unfilteredPlacesList);
    if (isEmpty($scope.savedTagsFilter)) {
      return;
    }
    const placesIds = uniq(flatten($scope.savedTagsFilter.map((tag) => tag.placeIds)));
    $scope.places = $scope.places.filter((place) => includes(placesIds, place._id));
    $scope.selectAllPlaces = false;
    $scope.disabledTagSelector = true;
  };

  const populateTagsSelector = () => {
    $scope.tagsGroupsList = flatten(
      map($scope.tagsGroups, (tg) =>
        map(tg.tags, (t) =>
          assign({ groupName: tg.name, enabled: tg.enabled, tagsGroupsId: tg._id }, t),
        ),
      ),
    );

    $scope.activeTags = $scope.tagsGroupsList.filter((tag) => tag.enabled);

    $scope.selectedTags = [];
  };

  const populatePlacesWithTags = () => {
    $scope.places = cloneDeep($scope.unfilteredPlacesList);
    $scope.places.forEach((place) => {
      place.tagsGroup = [];
      const tagsByPlace = $scope.tagsGroupsList.filter((tag) => includes(tag.placeIds, place._id));
      const groupsIds = uniq(tagsByPlace.map((tag) => tag.tagsGroupsId));
      groupsIds.forEach((groupId) => {
        const group = tagsByPlace.filter((tag) => tag.tagsGroupsId === groupId);
        const tagGroup = { groupName: group[0].groupName, tags: group };
        place.tagsGroup.push(tagGroup);
      });
    });
    $scope.unfilteredPlacesList = cloneDeep($scope.places);
    $scope.savedTagsFilter = [];
    filterByTagGroup();
  };

  const user = localStorage.get('user');
  $scope.superAdmin = user && user.sudo;
  const placesPromise = $scope.superAdmin
    ? PlaceService.GetAllEnterpriseAsPromise()
    : PlaceService.GetAllAsPromise();
  placesPromise
    .then((places) => {
      $timeout(() => {
        $scope.places = map(places, (place) =>
          assign(
            { tags: [], selectedPlace: false },
            { _id: place._id, name: place.name, branchId: place.branchId, info: place.info },
          ),
        );
        $scope.unfilteredPlacesList = cloneDeep($scope.places);
        $scope.loaded = true;
        populateTagsSelector();
        populatePlacesWithTags();
      });
    })
    .catch(ErrorService.handler);

  // Modal Tag Group
  $scope.openTagGroup = (tagGroupId) => {
    const modal = $uibModal.open({
      templateUrl: '/templates/components/modals/tags-groups-modal.html',
      size: 'lg',
      controller: 'TagsGroupsModalController',
      controllerAs: 'modal',
      resolve: {
        tagGroupId: () => tagGroupId,
      },
    });

    modal.result.then((result) => {
      if (result === 'success') {
        populateTagsSelector();
      }
    });
  };

  $scope.enable = (tagGroup) => {
    TagsGroupsService.Enable(tagGroup).then(() => {
      populateTagsSelector();
      populatePlacesWithTags();
      $scope.places.forEach((place) => {
        place.selectedPlace = false;
      });
      $scope.disabledTagSelector = true;
    });
  };

  $scope.deleteFilters = () => {
    $scope.savedTagsFilter = [];
    $scope.searchBox.name = '';
    $scope.searchBox.info.address = '';
    $scope.searchBox.branchId = '';
    $scope.searchBox.info.state = '';
  };

  $scope.applyToAllPlaces = () => {
    $scope.selectAllPlaces = !$scope.selectAllPlaces;
    map($scope.places, (place) => {
      place.selectedPlace = $scope.selectAllPlaces;
    });
    $scope.disabledTagSelector = !some($scope.places, 'selectedPlace');
  };

  $scope.onSelectPlace = (place) => {
    $scope.selectAllPlaces = !!(place.selectedPlace && every($scope.places, 'selectedPlace'));
    $scope.disabledTagSelector = !some($scope.places, 'selectedPlace');
  };

  $scope.applyTag = async () => {
    const selectedPlaces = $scope.places
      .filter((place) => place.selectedPlace)
      .map((place) => place._id);

    if (!selectedPlaces.length || !$scope.selectedTags.length) {
      return;
    }

    selectedPlaces.forEach((placeId) => {
      $scope.selectedTags.forEach((tag) => {
        if (!includes(tag.placeIds, placeId)) {
          tag.placeIds.push(placeId);
        }
      });
    });

    const groupsIds = uniq($scope.selectedTags.map((tag) => tag.tagsGroupsId));

    const promiseGroupUpdate = groupsIds.forEach((groupId) =>
      TagsGroupsService.UpdateTags(groupId, $scope.tagsGroups[groupId].tags),
    );
    Promise.all(promiseGroupUpdate);
    populatePlacesWithTags();
    $scope.selectedTags = [];
    $scope.selectAllPlaces = false;
  };

  $scope.removeTagFromPlace = (tag, place) => {
    const { tagsGroupsId, tagName } = tag;
    const group = $scope.tagsGroups[tagsGroupsId];
    const tagIndex = group.tags.findIndex((t) => t.tagName === tagName);
    if (tagIndex !== -1) {
      const removedPlaceIdIndex = group.tags[tagIndex].placeIds.indexOf(place._id);
      if (removedPlaceIdIndex !== -1) {
        group.tags[tagIndex].placeIds.splice(removedPlaceIdIndex, 1);
      }
    }
    TagsGroupsService.UpdateTags(tagsGroupsId, group.tags).then(() => {
      populateTagsSelector();
      populatePlacesWithTags();
    });
  };

  $scope.$watch('savedTagsFilter.length', filterByTagGroup);

  $scope.$watch('places.length', () => {
    $scope.tagsFilterNotResults = isEmpty($scope.places);
  });
};

module.exports = module.controller('TagsController', TagsController);
